/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react'
import Topbar from '../../components/common/topbar/Topbar'
import { Brand, FilterTable, FilterTableType, Option, Store, TableAction, TableDetailCell, TableHeaderCell } from '../../model/models-module'
import { addParam } from '../../utils/CommonUtils'
import {useData} from '../../components/hooks/useData'
import DataTable from '../../components/common/datatable/Datatable'
import { Button, CircularProgress, FormControl, MenuItem, Select} from '@mui/material'
import classes from './Brands.module.css'
import { GridDTOWithListForCombo } from '../../model/dto-module'
import { useParams } from 'react-router-dom'
import NewsanIcons from '../../components/common/Icons'
import CloseIcon from '@mui/icons-material/Close'
import EditIcon from '@mui/icons-material/Edit';
import PopupSuccessError from '../../components/common/popup-success-error/PopupSuccessError'
import AxiosInterceptor from '../../services/http/AxiosInterceptor'
import axios from 'axios';
import CustomAutocomplete from '../../components/common/custom-autocomplete/CustomAutocomplete'
import ConfirmDialog from '../../components/common/confirm-dialog/ConfirmDialog'

const Brands = () => {
  const {id: idStore} = useParams();
  const client = AxiosInterceptor.addInterceptor(process.env.REACT_APP_API_BASE_URL)
  const [dataHeader, setDataHeader] = useState<TableHeaderCell[]>([]);
  const [dataTo, setDataTo] = useState<number>(50);
  const [countItems, setCountItems] = useState<number>(0);
  const [dataOffset, setDataOffset] = useState<number>(0);
  const [dataShow, setDataShow] = useState<TableDetailCell[]>([]);
  const [baseEndpoint, setBaseEndpoint] = useState<string>(`/brands/${idStore}`);
  const [endpoint, setEndPoint] = useState<string>('');
  const [params] = useState<Map<string,string>>(new Map());
  const [loading, error, dataGrid] = useData<GridDTOWithListForCombo<Brand>>(endpoint, 'GET', undefined);
  const [loadingSelectedStore, errorSelectedStore, dataSelectedStore] = useData<Store>(`/stores/${idStore}`, 'GET', undefined);
  const [showForm, setShowForm] = useState<boolean>(false);
  const [newEditItem, setNewEditItem] = useState<Brand>();
  const [selectedGend, setSelectedGend] = useState<Option>();
  const [selectedStore, setSelectedStore] = useState<Option>();


  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [loadingResponse, setLoadingResponse] = useState(false);
  const [errorResponse, setErrorResponse] = useState<string[] | null>(null);
  const [dataResponse, setDataResponse] = useState<string | null>(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [selectedIntegratorId, setSelectedIntegratorId] = useState<number | null>(null);
  const [categoryDescriptionFilter, setCategoryDescriptionFilter]= useState<string>();
  const [withNoRelationFilter, setWithNoRelationFilter]= useState<string>();

  useEffect(()=> {
    if (baseEndpoint == '') setBaseEndpoint(`/brands/${idStore}`)
  }, [baseEndpoint])

  useEffect(()=> {
    setDataOffset(0)
    addParam(dataTo, 'size', params, baseEndpoint, setEndPoint);
  }, [dataTo, baseEndpoint]);

  useEffect(()=> {
    setDataShow([])
    addParam(dataOffset, 'page', params, baseEndpoint, setEndPoint);
  }, [dataOffset, baseEndpoint]);

  useEffect(()=> {
    setDataShow([])
    setDataOffset(0)
    addParam(categoryDescriptionFilter, 'newsanDescription', params, baseEndpoint, setEndPoint);
  }, [categoryDescriptionFilter, baseEndpoint]);
  
  useEffect(()=> {
    setDataShow([])
    setDataOffset(0)
    addParam(withNoRelationFilter, 'withNoRelation', params, baseEndpoint, setEndPoint);
  }, [withNoRelationFilter, baseEndpoint]);

  useEffect(()=> {
    if(dataHeader.length === 0 ) {
      setDataHeader([
        new TableHeaderCell({label: 'GEND', key: 'gend', sorteable: false, filter: new FilterTable({type: FilterTableType.TEXT, placeholder: 'Busca aqui...', onChange(newVal) {
          setCategoryDescriptionFilter(newVal)
      }, })}),
      new TableHeaderCell({label: 'Tienda', key: 'store', sorteable: false, filter: new FilterTable({type: FilterTableType.COMBO, useCodeField: true, data:
        [{
          id: 1, code: '1', description: 'Sin Configurar',
        },
        {
          id: 0, code: '0', description: 'Configuradas'
        }
        ]
        , onChange(newVal) {
          setWithNoRelationFilter(newVal)
      },})}),
      ])  
    }
  })

  const deleteTemplateConfig = async (id: number) => {
    try{
      setLoadingResponse(true)
        await client.delete(`/brands/${id}`)
        setDataResponse('Eliminado con éxito!')
        setErrorResponse(null)
    } catch (error) {
      if (axios.isAxiosError(error)) {
        setErrorResponse(error.response?.data.message);
      } else if (error instanceof Error) {
        setErrorResponse([error.message]);
      } else {
        setErrorResponse(['Hubo un error en la solicitud']);
      }
    } finally {
      setLoadingResponse(false);
    } 
  }

  useEffect(()=> {
    if (newEditItem){
      setSelectedGend(dataGrid?.listForCombo.gend?.find(gend => gend.id == newEditItem.gend.id))
      setSelectedStore(dataGrid?.listForCombo.store?.find(store => store.id == newEditItem.store.id))
    }
  }, [newEditItem])

  useEffect(()=>{
    if(!loading && dataGrid) {
      setCountItems(dataGrid.count)
      setDataShow(dataGrid.results.map((r) => {
        return new TableDetailCell({gend: dataGrid.listForCombo.gend.find((i) => i.id == r.gend.id)?.description, store: dataGrid.listForCombo.store.find((i) => i.id == r.store.id)?.description ?? <span className={classes.error}>Sin configurar</span> }, [
          new TableAction({label: 'Editar', action: () => {
            formatForm()
            setNewEditItem(r)
            setShowForm(true)
          }, icon: <span className={classes.editIcon}><EditIcon></EditIcon></span>}),
          new TableAction({label: 'Eliminar', action: async () => {
            await handleDeleteClick(r.id);
          },
          icon: NewsanIcons.DELETE
          }),
        ], undefined, classes['storesDataTable'])
      }))
    }
  }, [setDataShow, dataGrid, loading]);

  function reloadTable() {
    setBaseEndpoint('')
    setEndPoint('')
  }
  const fetchData = async ( body?: {gendId: number, storeId: number}) => {
    try{
      setLoadingResponse(true)
      newEditItem?.id ? await client.patch(`/brands/${newEditItem?.id}`, body) : await client.post(`/brands/createRelation`, body)
      setDataResponse('Modificado con éxito!')
      setErrorResponse(null)
      setNewEditItem(undefined)
      formatForm()
      setShowForm(false)
    } catch (error) {
      if (axios.isAxiosError(error)) {
        setErrorResponse(error.response?.data.message);
      } else if (error instanceof Error) {
        setErrorResponse([error.message]);
      } else {
        setErrorResponse(['Hubo un error en la solicitud']);
      }
    } finally {
      setLoadingResponse(false);
    } 
  }

  const saveFormInfo = () => {
    if (!selectedGend || !selectedStore){
      alert('Se deben completar todos los campos')
    } else {
      const temporalObject: {gendId: number, storeId: number} = {
        gendId: selectedGend.id,
        storeId: selectedStore.id
      }
      setShowPopup(true);
      fetchData(temporalObject)
    }
  }

  const handleDeleteClick = (relationId: number) => {
    setSelectedIntegratorId(relationId);
    setOpenConfirmDialog(true);
  };

  const confirmDelete = async () => {
    if (selectedIntegratorId !== null) {
      setShowPopup(true);
      setOpenConfirmDialog(false);
      await deleteTemplateConfig(selectedIntegratorId);
      setSelectedIntegratorId(null);
    }
  };

  function formatForm(){
    setSelectedGend(undefined)
    setSelectedStore(undefined)
  }

  useEffect(() => {
    if (selectedGend?.id && dataGrid?.listForCombo.store.find((value) => value.description.toLocaleLowerCase() == selectedGend.description.toLocaleLowerCase()) && !selectedStore) {
      setSelectedStore(dataGrid?.listForCombo.store.find((value) => value.description.toLocaleLowerCase() == selectedGend.description.toLocaleLowerCase()))
    }
  }, [selectedGend]);

  return (
    <div className={classes.errorTransactionPage}>
      {
        loading || loadingSelectedStore ?
        <div className='loadingPage'>
          <CircularProgress className='circleProgress'/>
        </div>
        : null
      }
      <div className={classes.storesPage}>
      <Topbar title={`Marcas - Tienda ${dataSelectedStore?.description}`} backButton hasReloadIcon reloadPage={reloadTable} />
      <div
        className={
          showForm ? classes['table-templates-container-form-visible'] : classes['table-templates-container']
        }
        >
          <DataTable
            headers={dataHeader}
            rows={dataShow}
            countItems={countItems}
            rowsPerPage={dataTo}
            hasActions={true}
            appendOnScrollToBottom={false}
            onPageSizeChange={(size) => {setDataTo(size); setDataOffset(0); }}
            onPageChange={(page: number)=>{ setDataOffset(page-1) }}
            pageSelected={dataOffset+1}
            pageable={true}
            selectable={false}
            className={classes.storesDataTable}
          ></DataTable>
        </div>
      {showForm ? (
        <div className={classes['abm-container']}>
          <div className={classes['edit-form-container']}>
            <span className={classes['title-form']}>
              {NewsanIcons.ADD_OUTLINED}{' '}
              <span className={classes['title-form-text']}>Editar</span>
            </span>
            <CloseIcon
              className={classes['form-close-button']}
              onClick={() => {
                formatForm()
                setShowForm(false)
                setNewEditItem(undefined)
              }}
            ></CloseIcon>
            <CustomAutocomplete
              label="GEND"
              value={selectedGend}
              options={dataGrid?.listForCombo.gend || []}
              onChange={setSelectedGend}
            />

            <CustomAutocomplete
              label="Tienda"
              value={selectedStore}
              options={dataGrid?.listForCombo.store || []}
              onChange={setSelectedStore}
            />
            <div className={classes['buttons-container']}>
              <Button
                variant='contained'
                className={classes['btn-newsan-cancel']}
                onClick={() => {
                  setShowForm(false)
                  setNewEditItem(undefined)
                  setDataResponse(null)
                  setErrorResponse(null)
                  formatForm()
                }}
              >
                Cancelar
              </Button>
              <Button
                variant='contained'
                onClick={async() => {await saveFormInfo();}}
                className={classes['button-newsan-red']}
              >Guardar
              </Button>
            </div>
          </div>
        </div>
      ) : null}
      </div>

      <ConfirmDialog
        open={openConfirmDialog}
        onClose={() => setOpenConfirmDialog(false)}
        onConfirm={confirmDelete}
        title="Confirmar eliminación"
        message="¿Está seguro de que desea eliminar esta configuración?"
      />
        {showPopup ? (<PopupSuccessError
          open={showPopup}
          onClose={() =>{ 
            setShowPopup(false);
            setDataResponse(null)
            setBaseEndpoint(errorResponse == null ? '' : baseEndpoint)
            setErrorResponse(null)
          }}
          loading={loadingResponse}
          success={dataResponse !== null}
          successMessage={dataResponse}
          errorMessage={errorResponse}
        />)
      :
      <></>}
    </div>
  )
}

export default Brands;
